module.exports = __webpack_public_path__ + "static/media/ios.bd5de4dc.svg";